/* eslint-disable no-unused-expressions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable react/sort-comp */
/* eslint-disable no-nested-ternary */
import React, { useRef, useState, useEffect } from 'react';

import styled, { css } from 'styled-components';

import { Icon } from 'fpay-ui';

const ImageDown = styled(Icon)(
  ({ open }) => css`
    width: 24px;
    height: 24px;
    color: #a2a7ba;
    display: flex;
    transition: transform 200ms cubic-bezier(0, 0, 0.2, 1) 0ms;
    ${open &&
    css`
      transform: rotate(-180deg);
    `}
  `
);

const Input = styled.div(
  ({ theme }) => css`
    pointer-events: ${(props) => props.disabled && 'none'};
    width: 100%;
    max-width: 551px;
    height: 40px;
    display: flex;
    position: relative;
    ${theme.textTypes['Body-2-w400']}
    line-height: 1.71;
    text-align: left;
    color: ${theme.colors.gray800};
    border-radius: 4px;
    border: solid 1px ${theme.colors.gray500};
    background-color: ${theme.colors.gray200};
    align-items: center;
    justify-content: space-between;
    padding-left: 16px;
    padding-right: 16px;
    cursor: pointer;
    ${theme.breakpoint('md')} {
      width: 223px;
      margin-right: 16px;
    }
    :focus,
    :hover:not(:focus):not(:disabled) {
      border: solid 1px ${theme.colors.gbrand500};
    }
    ${theme.breakpoint('ll')} {
      width: 242px;
    }
  `
);

const MainUil = styled.ul(
  ({ theme }) => css`
    z-index: 2;
    width: 100%;
    max-width: 551px;
    background-color: #ffffff;
    list-style: none;
    border: 0;
    border-radius: 4px;
    position: absolute;
    box-sizing: border-box;
    margin-top: ${(props) => (props.transfer ? '203px' : '170px')};
    margin-left: -17px;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.16);
    background-color: #ffffff;
    border: 2px solid #ffffff;
    ${theme.breakpoint('md')} {
      width: 223px;
    }
    li {
      display: flex;
      ${theme.textTypes['Caption-w400']}
      line-height: normal;
      text-align: left;
      color: ${theme.colors.gray800};
      height: 32px;
      align-items: center;
      align-content: center;
      padding-right: 16px;
      padding-left: 16px;
      cursor: pointer;
      &:first-child {
        margin-top: 8px;
      }
      &:last-child {
        margin-bottom: 8px;
      }

      &:hover {
        color: ${theme.colors.gray800};
        background-color: ${theme.colors.gray200};
      }
    }
    label {
      cursor: pointer;
    }
    ${theme.breakpoint('ll')} {
      width: 242px;
    }
  `
);

const Dropdown = ({ items, placeholder, selectedMovement, isFiltered, transfer, disabled }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [options, setOptions] = useState(items);
  const [selectOption, setSelectOption] = useState(placeholder);
  const dropdownNode = useRef(null);

  const handleClickOutside = (e) => {
    e.preventDefault();
    const dropdowncontainer = dropdownNode.current;
    if (!dropdowncontainer) {
      return;
    }
    const { target } = e;
    if (target !== dropdowncontainer && !dropdowncontainer.contains(target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    setSelectOption(items?.find((i) => i.selected));
    // selectedMovement(items?.find((i) => i.selected));

    document.addEventListener('click', handleClickOutside);
    // eslint-disable-next-line
  }, [items]);

  useEffect(() => {
    // setSelectOption(items?.find((i) => i.selected));
    transfer && selectedMovement(items?.find((i) => i.selected));

    document.addEventListener('click', handleClickOutside);
    // eslint-disable-next-line
  }, [transfer]);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const onSingleSelectListItem = (item) => {
    setOptions(
      items.map((i) => {
        if (i.id === item.id) {
          i.selected = true;
        } else {
          i.selected = false;
        }
        return i;
      })
    );
    selectedMovement(items.find((i) => i.selected));
    setSelectOption(items.find((i) => i.selected));
    toggleDropdown();
  };

  useEffect(() => {
    !isFiltered && setSelectOption(placeholder);
    // eslint-disable-next-line
  }, [isFiltered]);

  const eachRadioLi = (item) => (
    <li
      key={item.id}
      id={`item-${item.id}`}
      className={item.selected ? 'list-item active' : 'list-item'}
      onClick={() => onSingleSelectListItem(item)}
      data-testid={`eachClick-${item.id}`}
    >
      <label className="radiomark" htmlFor={`t-${item.id}`}>
        {item.name}
      </label>
    </li>
  );

  const renderDisplay = () => (
    <MainUil className="mainUl" transfer={transfer}>
      {options.map((item) => eachRadioLi(item))}
    </MainUil>
  );
  return (
    <Input
      className="dropdowncomponent"
      ref={dropdownNode}
      onClick={() => toggleDropdown()}
      open={isOpen}
      data-testid="openClick"
      disabled={disabled}
    >
      <div className="heading ellipse" style={disabled && { color: '#838AA2' }}>
        {selectOption?.name || placeholder}
      </div>
      {isOpen && renderDisplay()}
      <ImageDown icon="ic-arrow-down" open={isOpen} />
    </Input>
  );
};

export default Dropdown;
